import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('profile.AllFeatureTrialPaywallPopup.CompanyType', {
    xeroOrg: 'Xero Organisation',
    qboOrg: 'QuickBooks Online Organisation',
});
